{
  "folders": {
    "actions": {
      "rename": "Renommer",
      "move_to": "Déplacer vers",
      "create_workspace": "Créer un espace de travail",
      "create_folder": "Créer un dossier",
      "delete": "Supprimer"
    },
    "forms": {
      "folder_name": "Nom du dossier",
      "enter_folder_name": "Entrez un nom de dossier",
      "my_folders": "Mes dossiers",
      "move_here": "Déplacer ici",
      "choose_folder": "Choisir un dossier"
    },
    "confirmations": {
      "delete_folder_title": "Supprimer le dossier?",
      "delete_folder_content": "Êtes-vous sûr de vouloir supprimer ce dossier? Vous ne pouvez pas annuler cette action.",
      "move_workspace": "Déplacer l'espace de travail"
    },
    "errors": {
      "unable_to_delete": "Impossible de supprimer"
    }
  },
  "members": {
    "team": "Équipe",
    "add_member": "Ajouter un membre",
    "add_team_members": "Ajouter des membres d'équipe",
    "team_member": "Membre de l'équipe",
    "who_add_placeholder": "Qui voulez-vous ajouter à cet espace de travail",
    "validation": {
      "select_team_member": "Veuillez sélectionner au moins un membre de l'équipe"
    },
    "confirmations": {
      "remove_member_title": "Êtes-vous sûr de vouloir supprimer ce membre?",
      "remove_member_content": "Cette personne n'aura plus accès à l'espace de travail."
    },
    "aria_labels": {
      "remove_member": "supprimer le membre {{email}}"
    }
  },
  "forms": {
    "title": "Titre",
    "folder": "Dossier",
    "icon": "Icône",
    "color": "Couleur",
    "firm_wide_access": "Autoriser l'accès à l'ensemble du cabinet",
    "read_only": "Lecture seule",
    "validation": {
      "title_required": "Veuillez entrer le titre du projet"
    },
    "placeholders": {
      "app_description": "De quoi parle votre application?",
      "workspace_description": "Comment allez-vous collaborer dans cet espace de travail"
    },
    "aria_labels": {
      "project_icon": "icône de projet {{index}}",
      "select_color": "sélectionner {{description}}"
    }
  },
  "actions": {
    "create_app": "Créer une application",
    "create_workspace": "Créer un espace de travail",
    "update_app": "Mettre à jour l'application",
    "update_workspace": "Mettre à jour l'espace de travail",
    "clone_app": "Cloner l'application",
    "clone_workspace": "Cloner l'espace de travail"
  },
  "status": {
    "loading_workspaces": "Chargement des espaces de travail",
    "search_no_results": "Impossible de trouver un/des espace(s) de travail avec le titre \"{{term}}\"",
    "no_workspaces": "Il n'y a pas d'espace de travail et de dossier pour vous, créez-en un maintenant"
  },
  "table": {
    "headers": {
      "name": "Nom",
      "owner": "Propriétaire",
      "created_at": "Créé le",
      "project": "Projet",
      "team_members": "Membres de l'équipe"
    }
  },
  "tooltips": {
    "firm_wide_workspace": "Espace de travail à l'échelle du cabinet"
  },
  "app": {
    "create_view_label": "Vue d'entreprise",
    "read_only": "Lecture seule",
    "no_access_message": "Vous n'avez pas accès à ce projet. Veuillez demander à la personne qui a partagé le lien avec vous de vous ajouter en tant que membre de l'équipe.",
    "search_no_results": "Impossible de trouver une/des application(s) avec le titre \"{{term}}\"",
    "no_apps_message": "Il n'y a pas d'application pour vous, créez-en une maintenant",
    "view_table": "Tableau",
    "view_grid": "Grille",
    "get_started_message": "Pour commencer, ajoutez votre première liste à partir du bouton + ci-dessus à gauche.",
    "unknown_tab_type": "Type d'onglet inconnu",
    "table": {
      "app_header": "Application",
      "workspace_header": "Espace de travail",
      "team_members_header": "Membres de l'équipe"
    },
    "team_share": "Équipe/Partager",
    "team": "Équipe"
  },
  "opportunities": {
    "form": {
      "header": "Opportunité",
      "company_label": "Sélectionner l'entreprise associée *",
      "company_placeholder": "Tapez pour rechercher une entreprise",
      "status_label": "Statut",
      "description_label": "Description",
      "description_placeholder": "Décrivez votre opportunité en une phrase",
      "tags_label": "Tags",
      "proposed_fee_label": "Frais proposés",
      "date_label": "Date de l'opportunité",
      "date_placeholder": "date",
      "internal_owner_label": "Propriétaire interne",
      "internal_owner_placeholder": "Qui sera responsable de cette opportunité?",
      "team_involved_label": "Autres inclus",
      "team_involved_placeholder": "Autres inclus dans cette opportunité?",
      "referral_source_label": "Source de référence",
      "referral_source_placeholder": "Qui a référé cette opportunité?"
    },
    "workspace": {
      "link_button": "Lier l'espace de travail",
      "link_modal_label": "Espaces de travail",
      "link_validation": "Veuillez sélectionner un espace de travail",
      "unlink_title": "dissocier l'opportunité de l'espace de travail",
      "unlink_confirmation": "Cliquez sur confirmer pour dissocier l'opportunité de l'espace de travail",
      "unlink_confirm_title": "Êtes-vous sûr de vouloir dissocier cette opportunité?",
      "actions": {
        "update": "Mettre à jour",
        "unlink": "Dissocier"
      },
      "custom_fields": {
        "section_header": "Colonnes de l'espace de travail"
      }
    },
    "opportunity_actions": {
      "add_opportunity": "Ajouter une opportunité",
      "add_column": "Ajouter une colonne"
    },
    "no_opportunities": {
      "title": "Aucune opportunité pour le moment",
      "description": "Vous n'avez ajouté aucune opportunité.",
      "call_to_action": "Commencez par créer une nouvelle opportunité dans votre espace de travail."
    },
    "filters": {
      "search_placeholder": "Rechercher",
      "assign_to": "Assigner à",
      "referral_source": "Source de référence",
      "date": "Date"
    },
    "errors": {
      "generic_error": "Quelque chose s'est mal passé, veuillez contacter le support"
    }
  },
  "more_actions": {
    "manage_columns": "Gérer les colonnes"
  },
  "project_actions": {
    "clone_app": "Cloner l'application",
    "clone_project": "Cloner le projet",
    "clone_workspace": "Cloner l'espace de travail",
    "edit_app": "Modifier l'application",
    "edit_workspace": "Modifier l'espace de travail",
    "archive_app": "Archiver l'application",
    "archive_workspace": "Archiver l'espace de travail",
    "copy_list_id": "Copier l'ID de liste",
    "link_to_teams": "Lier à Microsoft Teams",
    "rollup_fields": "Champs de cumul",
    "actions": "Actions"
  },
  "task_forms": {
    "task_label": "Tâche",
    "due_date_label": "Date d'échéance",
    "assign_to_label": "Assigner à",
    "task_placeholder": "Décrivez la tâche",
    "task_button": "Tâche",
    "task_validation": "Veuillez saisir une tâche"
  },
  "table_headers": {
    "name_header": "Nom",
    "owner_header": "Propriétaire",
    "created_at_header": "Créé le"
  },
  "modals": {
    "create_task": "Créer une tâche",
    "update_task": "Mettre à jour la tâche",
    "list_id_header": "ID de liste",
    "list_id_description": "ID de liste actuel pour une utilisation facile avec les API"
  },
  "confirmations": {
    "archive_app": "Cliquez sur confirmer pour archiver l'application.",
    "archive_workspace": "Cliquez sur confirmer pour archiver l'espace de travail.",
    "delete_note": "Êtes-vous sûr de vouloir supprimer cette note?",
    "delete_document": "Êtes-vous sûr de vouloir supprimer ce document?",
    "no_edit_access": "Vous n'avez pas d'accès en modification pour cet espace de travail"
  },
  "labels": {
    "remove_workspace": "Supprimer l'espace de travail",
    "document": "Document",
    "note": "Note",
    "workspace_actions": "Actions de l'espace de travail",
    "create_workspace_task": "créer une tâche d'espace de travail",
    "update_task": "mettre à jour la tâche",
    "create_note": "Créer une note",
    "edit_project_document": "modifier le document du projet",
    "add_document": "ajouter un document",
    "remove_project_document": "supprimer le document du projet"
  },
  "teams": {
    "modal_header": "Lier à Microsoft Teams",
    "modal_caption": "Pour vous donner, à vous et à votre équipe, un accès facile à vos projets NEXL, vous pouvez lier vos projets avec Microsoft Teams pour un accès facile et une collaboration accrue. Suivez les étapes ci-dessous pour ajouter votre projet à MS Teams.",
    "step_1_title": "Étape 1",
    "step_1_description": "Copiez le lien ci-dessous.",
    "step_2_title": "Étape 2",
    "step_2_description": "Ouvrez Microsoft Teams et naviguez vers le canal auquel vous souhaitez ajouter le projet NEXL ou créez un nouveau canal. Cliquez ensuite sur l'icône \"+\" en haut de la page du canal MS Teams pour ajouter un nouvel onglet.",
    "step_3_title": "Étape 3",
    "step_3_description": "Utilisez la zone de recherche en haut à droite pour rechercher \"Site Web\". Cliquez ensuite sur l'icône \"Site Web\" comme indiqué dans l'image ci-dessous.",
    "step_4_title": "Étape 4",
    "step_4_description": "Entrez un nom pour l'onglet et collez l'URL du projet NEXL dans le champ URL. Une fois terminé, cliquez sur \"Enregistrer\". Vous pouvez maintenant accéder à votre projet NEXL directement depuis Microsoft Teams.",
    "got_it_button": "Compris !",
    "microsoft_teams_tab_url_label": "url de l'onglet microsoft teams"
  },
  "objectives": {
    "title": "Objectifs",
    "add_objective": "Objectif"
  },
  "notes": {
    "title": "Notes",
    "description": "Partagez des commentaires et des notes avec votre équipe."
  },
  "template": {
    "use_template": "Utiliser le modèle",
    "cloning_status": "CLONAGE"
  },
  "overview": {
    "collaboration_title": "Comment nous allons collaborer",
    "tasks": {
      "title": "Tâches",
      "view_all": "Voir tout",
      "view_all_aria": "voir toutes les tâches dans cet espace de travail"
    }
  },
  "tabs": {
    "loading": "Chargement des onglets du projet..."
  },
  "workspaces": {
    "search_placeholder": "Rechercher des espaces de travail",
    "empty_search_results": "Impossible de trouver un/des espace(s) de travail avec le titre \"{{term}}\"",
    "empty_state": "Il n'y a pas d'espace de travail et de dossier pour vous, créez-en un maintenant",
    "views": {
      "table": "Tableau",
      "grid": "Grille",
      "folder": "Dossier",
      "toggle_view_aria": "basculer la vue"
    }
  },
  "rollup_fields": {
    "operation_label": "Opération",
    "column_field_label": "Champ de colonne",
    "column_field_tooltip": "Les champs disponibles dépendent de l'opérateur :\nSomme/Moyenne → Type Nombre, Devise\nMax/Min → Type Nombre, Devise, Date/Heure",
    "no_compatible_columns": "Aucune colonne compatible pour l'opérateur \"{{operation}}\"",
    "select_field_placeholder": "Sélectionner un champ...",
    "column_field_aria_label": "Champ de colonne",
    "operations": {
      "count": "Compter",
      "sum": "Somme",
      "average": "Moyenne",
      "min": "Minimum",
      "max": "Maximum"
    }
  }
}
